import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when a category has a child missing in the chart of accounts tree.
 *
 * @param {string} spec.childId - Id expected to be found in the chart of accounts
 * @param {string} spec.categoryId - Category having an absent group
 */
export default class CategoryWithAbsentChildValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor(spec) {
		super(spec);

		this._category = this._chartOfAccounts.findById(spec.categoryId);
		this._childId = spec.childId;
	}

	getChildId() {
		return this._childId;
	}

	getCategory() {
		return this._category;
	}

	getMessage() {
		return _(
			'The category "{name}" expect the group with id {id} to be found in the chart of accounts.',
			{
				name: this._category.getName(),
				id: this._expectedId,
			},
		);
	}

	static getType() {
		return "CategoryWithAbsentChildException";
	}
}
